import { css, genDynamicVariant } from '@backyard-ui/styles';

const baseStyles = css({
  display: 'block',
  marginBottom: '$6',
  fontFamily: '$default',
  fontWeight: '$bold',
  lineHeight: 1.2,
  variants: {
    color: genDynamicVariant('colors', (value) => ({
      color: value,
    })),
    size: {
      xs: {
        fontSize: '$hxs',
      },
      sm: {
        fontSize: '$hsm',
      },
      md: {
        fontSize: '$hmd',
      },
      lg: {
        fontSize: '$hlg',
      },
      xl: {
        fontSize: '$hlg',
        '@md': {
          fontSize: '$hxl',
        },
      },
      '2xl': {
        fontSize: '$hxl',
        '@md': {
          fontSize: '$h2xl',
        },
      },
      '3xl': {
        fontSize: '$h2xl',
        '@md': {
          fontSize: '$h3xl',
        },
      },
      '4xl': {
        fontSize: '$h2xl',
        '@md': {
          fontSize: '$h4xl',
        },
      },
      '5xl': {
        fontSize: '$h2xl',
        '@md': {
          fontSize: '$h5xl',
        },
      },
      '6xl': {
        fontSize: '$h2xl',
        '@md': {
          fontSize: '$h6xl',
        },
      },
    },
    align: {
      left: {
        textAlign: 'left',
      },
      center: {
        textAlign: 'center',
      },
      right: {
        textAlign: 'right',
      },
      justify: {
        textAlign: 'justify',
      },
    },
    isCasing: {
      true: {
        textTransform: 'uppercase',
      },
    },
    isItalic: {
      true: {
        fontStyle: 'italic',
      },
    },
    noMargin: {
      true: {
        margin: '$0',
      },
    },
  },
  defaultVariants: {
    size: 'xl',
  },
});

export default baseStyles;
